<template>
  <section class="hero dubai">
      <div class="hero__content container">
        <div class="hero__content--info">
          <h1 class="hero__title">
            DNA House x IBC, TOKEN2049<br>at <a href="https://maps.app.goo.gl/uoGNhMBED8sAWMg37" target="_blank">Gigi Rigolatto Dubai</a>
          </h1>
          <h2 class="hero__date">
            April 30th - May 1st, 2025
          </h2>
          <a href="http://lu.ma/dnafund" target="_blank">
            <button class="hero__btn">
              Register Now
            </button>
          </a>
          <div class="venue-logo">
            <a href="https://multibank.io/" target="_blank">
              <img src="@/assets/general/dubai-v.png" class="tall" alt="Gigi Logo">
            </a>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>

  export default {
    name: 'Hero',
    data () {
      return {
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  @import "@/styles/components/hero.scss";

  .hero.dubai {
    padding: 100px 0 20px;
    min-height: 500px;
    background-image: linear-gradient(to bottom, rgb(0 0 0 / 90%) 0%, rgb(0 0 0 /65%)), url('~@/assets/general/gigis.jpg');
  }
  </style>